<template>
    <common-modal width="medium" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer class="pending-insurance-info" height="medium" :isCenter="true">
            <common-page-header :heading="heading" :isCenter="true"></common-page-header>
            <div>
                <hr />
                <div v-if="isReferringPhysician" class="pending-insurance-info__insurance-plan">
                    <p>{{ $t('pages.referrals.show.insurance_modal.patient_insurance_plan') }}</p>
                    <p>{{ referral.insurancePlan.name }}</p>
                </div>

                <user-details
                    v-else
                    :user="referral.primaryCarePhysician"
                    :bottomText="$t('common.practice_type.physician')"
                    :showEmail="true"
                    :showPhone="true"
                ></user-details>
            </div>
            <div class="buttons">
                <common-buttons>
                    <common-button
                        :label="$t('pages.referrals.show.insurance_modal.buttons.done')"
                        type="primary"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                </common-buttons>
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import UserDetails from 'components/page-elements/referrals/details/UserDetailsCard'

    export default {
        components: {
            UserDetails,
        },

        props: {
            referral: { type: Object, required: true },
        },

        computed: {
            isReferringPhysician() {
                return this.$auth.getActiveMember().id === this.referral.fromUser.id
            },

            heading() {
                return this.isReferringPhysician
                    ? this.$t('pages.referrals.show.insurance_modal.heading_reffering')
                    : this.$t('pages.referrals.show.insurance_modal.heading_referred')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .pending-insurance-info {
        h2 {
            text-align: center;
        }
        hr {
            height: 1px;
            background-color: #dfdfdf;
            border: none;
            width: 60%;
            margin: 1rem auto;
        }
        .buttons {
            margin-top: 2rem;
        }

        &__insurance-plan {
            text-align: center;
            font-size: 18px;
            letter-spacing: 0.31px;
            p:first-child {
                color: #333333;
            }
        }
    }
</style>
